import {
  BEGIN_AVATAR_DRAG,
  END_AVATAR_UPLOAD,
  FINISH_AVATAR_DRAG,
  START_AVATAR_UPLOAD,
  UPDATE_AVATARS,
} from 'constants/actions';

const DEFAULT_STATE = {
  currently_dragging: null,
  uploading: false,
  avatars: [],
};

const avatarReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case UPDATE_AVATARS:
      return { ...state, avatars: action.avatars };
    case BEGIN_AVATAR_DRAG:
      return { ...state, currently_dragging: action.pos };
    case FINISH_AVATAR_DRAG:
      return { ...state, currently_dragging: null };
    case START_AVATAR_UPLOAD:
      return { ...state, uploading: true };
    case END_AVATAR_UPLOAD:
      return { ...state, uploading: false };
    default:
      return state;
  }
};

export default avatarReducer;
